import React, { useCallback, useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { AuthContext } from '../context/contexts';
import { useNavigate } from 'react-router-dom';

export const AuthProvider = ({ children, setOpen }) => {
  const [isAuthenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const reAuthenticate = useCallback(() => {
    const auth = localStorage.getItem('auth');

    if (!auth) {
      setAuthenticated(false);
      setUser({});
      setLoading(false);
      return false;
    }

    try {
      const decoded = jwtDecode(auth);
      const { exp } = decoded;
      const now = Math.floor(Date.now() / 1000);

      if (exp > now) {
        setAuthenticated(true);
        setUser(decoded);
        setLoading(false);
        return true;
      } else {
        localStorage.removeItem('auth');
        setAuthenticated(false);
        setUser({});
        setLoading(false);
        return false;
      }
    } catch (error) {
      localStorage.removeItem('auth');
      setAuthenticated(false);
      setUser({});
      setLoading(false);
      return false;
    }
  }, []);

  // Only run on mount
  useEffect(() => {
    reAuthenticate();
  }, [reAuthenticate]);

  const logout = () => {
    localStorage.removeItem('auth');
    setAuthenticated(false);
    setUser({});
    setOpen(false);

    setTimeout(() => {
      navigate('/login', { state: { logout: 'Logged out successfully' } });
    }, 1000);
  };

  return <AuthContext.Provider
    value={{
      isAuthenticated,
      setAuthenticated,
      user,
      setUser,
      logout,
      reAuthenticate,
      loading
    }}>
    {children}
  </AuthContext.Provider>;
};
